import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Badge } from '../../../components/ui/badge';

export const CommunitySettings: React.FC = () => {
    const { t } = useTranslation('common');

    // Mock data for now, as it was hardcoded in original
    const communities = [
        {
            id: 'taothao',
            name: 'TaoThaoAIPro',
            members: 12500,
            isFree: true,
            initials: 'TAO'
        }
    ];

    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-2xl font-bold tracking-tight">{t('settings.community.title', { defaultValue: 'Communities' })}</h2>
                <p className="text-muted-foreground">
                    {t('settings.community.description', { defaultValue: 'Manage your communities settings.' })}
                </p>
            </div>

            <div className="grid gap-4">
                {communities.map(community => (
                    <Card key={community.id}>
                        <CardContent className="flex items-center justify-between p-6">
                            <div className="flex items-center gap-4">
                                <div className="flex bg-primary/10 w-12 h-12 items-center justify-center rounded-lg text-primary font-bold">
                                    {community.initials}
                                </div>
                                <div className="space-y-1">
                                    <h3 className="font-semibold">{community.name}</h3>
                                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                                        <span>{t('settings.community.membersCount', { count: community.members, defaultValue: '{{count}} members' })}</span>
                                        <span>•</span>
                                        <Badge variant="secondary">{community.isFree ? t('settings.community.free', { defaultValue: 'Free' }) : 'Paid'}</Badge>
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <Button variant="outline" size="sm">
                                    {t('settings.community.configure', { defaultValue: 'Configure' })}
                                </Button>
                                {/* Additional actions like Pin/Hide could go here */}
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};
